module.exports = __webpack_public_path__ + "static/media/home-hero-pic.a92fbad1.png";